module.exports = __webpack_public_path__ + "media/img/laura-96c3aafb.png";